@if (label) {
	<ic-label [help]="help" [missing]="missing" [missingText]="missingText" [required]="required">
		{{ label }}
	</ic-label>
}

<div class="border" [class.disabled]="disabled" [class.icon-right]="iconRight" [formGroup]="innerForm">
	<span class="icon">
		@if (!innerForm.get("value").value || hideClear || disabled) {
			<i aria-hidden="true" [class]="icon"> </i>
		} @else {
			<i class="clear fa fa-times-circle" (click)="clearForm()"> </i>
		}
	</span>
	<input
		#input
		formControlName="input"
		type="text"
		[attr.maxlength]="maxlength"
		[class.show-input]="!value"
		[placeholder]="placeholder"
		(focus)="onFocus()"
	/>

	@if (value) {
		<p class="value-template">
			@if (valueTemplate) {
				<ng-template [ngTemplateOutlet]="valueTemplate" [ngTemplateOutletContext]="{ $implicit: value }" />
			} @else {
				{{ value }}
			}
		</p>
	}
</div>
<ng-content select=".errors" />

@if (showList && !disabled) {
	<div class="autocomplete-options" [class.icon-right]="iconRight">
		@if (!loading) {
			<ul>
				@if (items && items.length > 0) {
					@for (item of items; track item) {
						<li
							[attr.data-test]="'option-' + item.id"
							[class.disabled]="disableClickHandler(item) || item.selectIsDisabled"
							(click)="selectOption(item)"
						>
							<ng-template [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{ $implicit: item }" />
						</li>
					}
				} @else {
					<li><ng-template [ngTemplateOutlet]="emptyTemplate" /></li>
				}
			</ul>
		} @else {
			<div class="loading"><ng-template [ngTemplateOutlet]="loadingTemplate" /></div>
		}
	</div>
}
